var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Follow.UserAdd",
    "options": {
        "objc_class_prefix": "FollowUserAdd",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "Request",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "fuid",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "addFriend",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "content",
                    "id": 3
                }
            ]
        },
        {
            "name": "Response",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "followType",
                    "id": 1
                }
            ]
        }
    ]
}).build();
export default _root;



// WEBPACK FOOTER //
// ./js/_service/pb/FollowUserAdd.pb.js